export default function convertScore(value: string | number) {
  return typeof value === "string" ? Number(value).toFixed(5) : value.toFixed(5);
}
